import React from 'react';
import times from 'lodash/times';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Card } from '../../../../../../CommonComponents/OPL/Card/Card';
import { Shimmer } from '../../../../../../CommonComponents/OPL/Shimmer/Shimmer';

export const HiddenLeversRiskScoreLoading = () => {
  return (
    <Card p="32" mb="16">
      <Box
        display="flex"
        flexDirection="column"
        width="100%"
        alignItems="center"
        justifyContent="center"
        py="32"
      >
        <Shimmer
          width="130px"
          height="130px"
          css={`
            border-radius: 50%;
          `}
        />

        <Box maxWidth="540px" width="100%" m="auto" p="32">
          <Shimmer width="100%" height="24px" />
          <Shimmer width="100%" height="24px" mt="8" />
        </Box>
      </Box>

      <Box display="flex" justifyContent="space-evenly" gridGap="16">
        {times(3).map(key => (
          <Box display="flex" width="100%" key={key}>
            <Shimmer
              minWidth="80px"
              width="80px"
              height="80px"
              css={`
                border-radius: 50%;
              `}
            />

            <Box pl="16" width="100%">
              <Shimmer width="100px" height="32px" />
              <Shimmer width="100%" height="24px" mt="4" />
              <Shimmer width="100%" height="24px" mt="4" />
              <Shimmer width="80%" height="24px" mt="4" />
            </Box>
          </Box>
        ))}
      </Box>

      <Box pt="32" css="text-align: center" width="100%">
        <Shimmer width="150px" height="24px" m="auto" />
      </Box>
    </Card>
  );
};
